import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {UrlConstants} from '../../../constants/url.constants';
import {RegistrationDto} from '../../../models/registration/registrationdto';
import {RegistrationResponse} from '../../../models/registration/registration-response';

@Injectable({
    providedIn: "root",
})
export class RegistrationService {

    readonly http = inject(HttpClient);

    validateRegistrationDtls(registrationDtls: RegistrationDto): Observable<RegistrationDto> {
        return this.http.post<RegistrationDto>(UrlConstants.REGISTRATION_VALIDATION_URL, registrationDtls);
    }

    registerUser(registrationDtls: RegistrationDto): Observable<RegistrationResponse> {
        return this.http.post<RegistrationResponse>(UrlConstants.REGISTRATION_URL, registrationDtls);
    }

}
